<ion-row class="search-and-actions" *ngIf="(ingredients ?? []).length > 0">
  <ion-col size="3"></ion-col>
  <ion-col offset="5" size="4" class="add-column">
    <div>
      <ng-container [ngTemplateOutlet]="addIngredientsButton"></ng-container>
    </div>
  </ion-col>
</ion-row>
<ion-row class="headers" *ngIf="(ingredients ?? []).length > 0">
  <ng-container
    *ngIf="platform === platformRef.desktop"
    [ngTemplateOutlet]="desktopHeaders"
  ></ng-container>
  <ng-container
    *ngIf="platform === platformRef.tablet"
    [ngTemplateOutlet]="tabletHeaders"
  ></ng-container>
</ion-row>
<ion-row
  *ngIf="(ingredients ?? []).length === 0"
  class="no-ingredients-container"
>
  <ng-container [ngTemplateOutlet]="noIngredients"></ng-container>
</ion-row>
<ion-row class="ingredientCard" *ngFor="let ingredient of ingredients">
  <ion-col size="12">
    <app-ingredients-card
      [cardData]="ingredient"
      [platform]="platform"
      [containerSize]="containerSize"
      [lockEdits]="lockEdits"
      (uomDropdownClickEvent)="onUomDropdownClickEvent($event)"
      (noteInputBlurEvent)="onNoteInputBlurEvent($event)"
      (quantityInputBlurEvent)="onQuantityInputBlurEvent($event)"
      (nameClickEvent)="onNameClick($event)"
      (ellipsisEvent)="onEllipsisClick($event)"
      (costInfoIconEvent)="clickInfoIcon($event)"
      (dismissCostInfoPopover)="dismissCostInfoPopoverEvent()"
    >
    </app-ingredients-card>
  </ion-col>
</ion-row>

<ng-template #desktopHeaders>
  <ion-col [size]="0.5" [offset]="0.1288" *ngIf="containerSize > 11"></ion-col>
  <ion-col
    class="padding"
    [size]="containerSize > 11 ? 2.5 : 4.35"
    [offset]="containerSize > 11 ? 0.1488 : 0.8888"
  >
    {{ 'i18n.menuProfitPro.ingredient.item' | translate }}
  </ion-col>
  <ion-col
    [size]="containerSize > 11 ? 0.75 : 1.15"
    [offset]="containerSize > 11 ? 0.1288 : 0.6388"
  >
    {{ 'i18n.menuProfitPro.ingredient.quantity' | translate }}
  </ion-col>
  <ion-col
    [size]="containerSize > 11 ? 1 : 2"
    [offset]="containerSize > 11 ? 0.1388 : 0.6388"
  >
    {{ 'i18n.menuProfitPro.ingredient.uOfM' | translate }}
  </ion-col>
  <ion-col [size]="1" [offset]="0.1388" *ngIf="containerSize > 11">
    {{ 'i18n.menuProfitPro.ingredient.type' | translate }}
  </ion-col>
  <ion-col [size]="1" [offset]="0.1388" *ngIf="containerSize > 11">
    {{ 'i18n.menuProfitPro.ingredient.brand' | translate }}
  </ion-col>
  <ion-col [size]="1" [offset]="0.1388" class="cost" *ngIf="containerSize > 11">
    {{ 'i18n.menuProfitPro.ingredient.cost' | translate }}
  </ion-col>
  <ion-col [size]="2" [offset]="0.1388" *ngIf="containerSize > 11">
    {{ 'i18n.menuProfitPro.ingredient.note' | translate }}
  </ion-col>
  <ion-col [size]="0.25" [offset]="0.25" *ngIf="containerSize > 11"> </ion-col>
  <ion-col [size]="0.5" *ngIf="containerSize > 11"> </ion-col>
</ng-template>

<ng-template #tabletHeaders>
  <ion-col [size]="6" [offset]="1.125">
    {{ 'i18n.menuProfitPro.ingredient.item' | translate }}
  </ion-col>
  <ion-col [size]="1" [offset]="0.325">
    {{ 'i18n.menuProfitPro.ingredient.quantity' | translate }}
  </ion-col>
  <ion-col [size]="2" [offset]="0.25">
    {{ 'i18n.menuProfitPro.ingredient.uOfM' | translate }}
  </ion-col>
</ng-template>

<ng-template #noIngredients>
  <div class="no-ingredients">
    <img
      src="assets/images/box-dimension-black.svg"
      class="box-dimension-image"
      alt="box-image"
    />
    <p>{{ 'i18n.menuProfitPro.recipeDetail.noIngredient' | translate }}</p>
    <ng-container [ngTemplateOutlet]="addIngredientsButton"></ng-container>
  </div>
</ng-template>

<ng-template #addIngredientsButton>
  <ion-button
    [class]="'usf-fill-green-button add-ing'"
    [class.disabled]="lockEdits"
    data-cy="recipe-page-add-ingredient-button"
    (click)="onAddIngredients()"
    [disabled]="lockEdits"
  >
    {{ 'i18n.menuProfitPro.recipeDetail.addIngredient' | translate }}
    <ion-icon
      data-cy="recipe-page-add-ingredient-button-icon"
      name="add-outline"
    ></ion-icon>
  </ion-button>
</ng-template>
